import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomLabelTagCircular = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="m13.667 16.84-2.778-1.23-2.778 1.23V9.432h5.556zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2M8.556 17.898l2.333-1.03 2.333 1.03q.555.243 1.056-.093.5-.336.5-.951V9.432q0-.472-.327-.808a1.06 1.06 0 0 0-.784-.336H8.11q-.458 0-.785.336A1.12 1.12 0 0 0 7 9.432v7.422q0 .615.5.951t1.056.093m7.333-10.754v9.724H17V7.144q0-.472-.326-.808A1.06 1.06 0 0 0 15.889 6H8.667v1.144z"
  />,
  'CustomLabelTagCircular',
);

export default CustomLabelTagCircular;
